module.exports = "<app-nav></app-nav>\n<div class=\"wrapper\">\n  <div class=\"app-container\">\n    <router-outlet></router-outlet>\n  </div>\n</div>\n"